import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import Navbar from "./components/Navbar";  
import Footer from "./components/Footer";   // ✅ Footer import
import Preview from "./pages/Preview";

function App() {
  return (
    <Router>
      {/* Top Navbar */}
      <Navbar />  

      {/* Main Pages */}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/dashboard/*" element={<Dashboard />} />
        <Route path="/preview" element={<Preview />} />
      </Routes>

      {/* Bottom Footer */}
      <Footer />  
    </Router>
  );
}

export default App;
